import { render } from "./clipboard.vue?vue&type=template&id=1b2539ec"
import script from "./clipboard.vue?vue&type=script&lang=js"
export * from "./clipboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/thecompcodes-dashboard/thecompcodes-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__